import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { queryClient } from 'providers/AllProviders';
import { createTaggings, destroyTagging, getTaggedRecords, getTaggingContexts } from './api';
import { CreateTaggingsPayload, TagContexts, TaggedRecordsResponse } from './types';

export function useGetTaggingContexts(options?: UseQueryOptions<TagContexts, Error>) {
  return useQuery<TagContexts>({
    queryKey: ['tagging_contexts'],
    queryFn: getTaggingContexts,
    staleTime: 1000 * 60 * 5,
    ...options
  });
}

export function useGetTaggedRecords(
  params?: Record<string, unknown>,
  options?: UseQueryOptions<TaggedRecordsResponse, Error>
) {
  return useQuery<TaggedRecordsResponse>({
    queryKey: ['taggings', params],
    queryFn: () => getTaggedRecords(params),
    ...options
  });
}

export function useCreateTaggings(onSuccess?: () => void) {
  return useMutation({
    mutationFn: (payload: CreateTaggingsPayload) => createTaggings(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['taggings'] });
      queryClient.invalidateQueries({ queryKey: ['tagging_contexts'] });
      queryClient.invalidateQueries({ queryKey: ['businesses'] });
      onSuccess?.();
    }
  });
}

export function useDestroyTagging(onSuccess?: () => void) {
  return useMutation({
    mutationFn: (taggingId: number) => destroyTagging(taggingId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['taggings'] });
      queryClient.invalidateQueries({ queryKey: ['tagging_contexts'] });
      queryClient.invalidateQueries({ queryKey: ['businesses'] });
      onSuccess?.();
    }
  });
}
